module.exports = __webpack_public_path__ + "img/1F1E9-1F1EA.6a49c346.svg";